import { HeaderHeightContext } from 'expo-router/react-navigation';
import { useContext } from 'react';
import { Platform } from 'react-native';

import { SupportRecipientPicker } from './SupportRecipientPicker';

import { Header } from '@/components/header';
import { useLiquidGlass } from '@/components/ui/glass';
import { VStack } from '@/components/ui/vstack';
import { ROUTES } from '@/constants/routes';
import { useColors } from '@/hooks/useColors';
import type { SearchUsersV2User } from '@/services/searchUsersV2';

const IS_IOS = Platform.OS === 'ios';

const TITLE = 'New message';

type NewSupportMessageScreenProps = {
  onSelect: (user: SearchUsersV2User) => void;
  pendingUserId?: number;
};

/**
 * Where staff acting as Primum Support pick the person to message. Dressed like
 * the support thread it leads into: the bar floats over the list where iOS draws
 * Liquid Glass, and is opaque in the list's own fill everywhere else.
 */
export function NewSupportMessageScreen({ onSelect, pendingUserId }: NewSupportMessageScreenProps) {
  const { colors } = useColors();

  const hasGlass = useLiquidGlass();

  const headerHeight = useContext(HeaderHeightContext) ?? 0;

  const isHeaderTransparent = IS_IOS && hasGlass;

  return (
    <VStack className="w-full flex-1 bg-background-50">
      <Header
        headerShadowVisible
        isBackButton
        backRoute={ROUTES.INBOX}
        contentScrollsUnderHeader
        statusBarBackgroundColor={colors.background[50]}
        headerStyle={{ backgroundColor: colors.background[50] }}
        title={TITLE}
      />

      <SupportRecipientPicker
        onSelect={onSelect}
        pendingUserId={pendingUserId}
        topInset={isHeaderTransparent ? headerHeight : 0}
      />
    </VStack>
  );
}
